<template>
</template>
       
<script>
  export default {
    name: 'reload',
            
    mounted () {
        this.$router.push({ name: 'pedido' });
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/pedido/reload.vue